<script setup>
import { inject, computed } from 'vue';
import { getDescElement } from '@/scripts/global.js';
import Expression from './Expression.vue';
import MenuModele from './MenuModele.vue';

const { modele } = defineProps({
  modele: Object
});

const premierElementSelectionne = inject('premierElementSelectionne');
const donnerFocusAuRapport = inject('donnerFocusAuRapport');

const descElementSelectionne = computed(() => {
    return getDescElement(premierElementSelectionne.value);
});

</script>

<template>
    <div class="barre-menu">
        <i class='icone-desc-selection' :class="descElementSelectionne?.icone" v-tooltip.bottom="descElementSelectionne?.libelle"/>
        <Expression 
          @annuler="donnerFocusAuRapport()"/>
        <MenuModele :modele="modele"/>
    </div>
</template>

<style scoped>

.barre-menu {
    display: flex;
    border-bottom:  2px inset whitesmoke;
    align-items: stretch;
    background-color: var(--couleur-fond-zone-expression);
}

.icone-desc-selection {
    margin: 9px 5px 0px 10px;
    font-size: 14px;
    color: var(--couleur-primaire);
}

</style>